
  import { defineComponent, PropType } from 'vue';
  import { mapActions, mapGetters } from 'vuex';

  import {
    REGION_DASHBOARDS_VES_ACTIONS_NAME,
    REGION_DASHBOARDS_VES_GETTERS_NAME,
  } from '../../../store/regionDashboards/name';
  import {
    TDashboardRegionRepresentativeAbroadFilter,
    TDashboardRegionRepresentativeAbroadFilterPayload,
  } from '../../../types/regionDashboards';
  import RegionDashBoardsRepresentativeInfoList from './RegionDashBoardsRepresentativeInfoList.vue';

  export default defineComponent({
    name: 'RegionDashboardsRepresentativeAbroadBaseInfo',
    components: {
      RegionDashBoardsRepresentativeInfoList,
    },
    props: {
      filter: {
        type: Object as PropType<TDashboardRegionRepresentativeAbroadFilter>,
        required: true,
      },
    },
    data(): { representativeAbroadInfoAbortController: AbortController; isLoading: boolean } {
      return {
        representativeAbroadInfoAbortController: new AbortController(),
        isLoading: false,
      };
    },
    computed: {
      ...mapGetters({
        representativeAbroadInfo: REGION_DASHBOARDS_VES_GETTERS_NAME.getRepresentativeAbroadInfo,
      }),
    },
    methods: {
      ...mapActions({
        getRepresentativeAbroadInfo: REGION_DASHBOARDS_VES_ACTIONS_NAME.getRepresentativeAbroadInfo,
      }),
      getDisplayValue(value: string | undefined) {
        return this.isLoading ? '' : value ?? '-';
      },
    },
    watch: {
      filter: {
        async handler(newFilter: TDashboardRegionRepresentativeAbroadFilter) {
          this.representativeAbroadInfoAbortController.abort();
          this.representativeAbroadInfoAbortController = new AbortController();

          this.isLoading = true;

          const payload: TDashboardRegionRepresentativeAbroadFilterPayload = {
            params: newFilter,
            abortController: this.representativeAbroadInfoAbortController,
          };

          await this.getRepresentativeAbroadInfo(payload);

          this.isLoading = false;
        },
        immediate: true,
        deep: true,
      },
    },
  });
